/** Reorder visible IDs and merge back into full column order preserving hidden columns */
export function mergeColumnOrder(
  newVisibleOrder: string[],
  fullColumnOrder: string[] | undefined
): string[] {
  if (!fullColumnOrder || fullColumnOrder.length === 0) return newVisibleOrder

  const visibleSet = new Set(newVisibleOrder)
  let vi = 0
  return fullColumnOrder.map(id => (visibleSet.has(id) ? newVisibleOrder[vi++]! : id))
}

/** Compute new visible order after moving a column from originIndex to targetIndex */
export function reorderColumn(
  headerIds: string[],
  originIndex: number,
  targetIndex: number
): string[] | null {
  const newOrder = [...headerIds]
  const [moved] = newOrder.splice(originIndex, 1)
  if (!moved) return null
  newOrder.splice(targetIndex, 0, moved)
  return newOrder
}
